import { AuthConfig } from 'angular-oauth2-oidc'

export const authCodeFlowConfig: AuthConfig = {
  issuer: 'https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_wjXivpiwU',
  logoutUrl: 'https://auth.pixceleration.com/logout',
  redirectUri: window.location.origin,
  clientId: '1so8j1g8cbcimq05q0e3km9975',
  responseType: 'code',
  scope: 'openid',
  showDebugInformation: true,
  strictDiscoveryDocumentValidation: false,
}
